import { render, staticRenderFns } from "./EmailMessageAttachments.vue?vue&type=template&id=31d6f467&scoped=true&"
import script from "./EmailMessageAttachments.vue?vue&type=script&lang=js&"
export * from "./EmailMessageAttachments.vue?vue&type=script&lang=js&"
import style0 from "./EmailMessageAttachments.vue?vue&type=style&index=0&id=31d6f467&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d6f467",
  null
  
)

export default component.exports